import React, { useState } from 'react';
import { MDBSideNavCollapse, MDBSideNavItem, MDBSideNavLink, MDBSelect } from 'mdb-react-ui-kit';

const Status = ({ userSelectedStatus, setUserSelectedStatus }) => {
    const [collapse, setCollapse] = useState(false);
    const statusOptions = [
        {
            text: "All",
            value: "All"
        },
        {
            text: "Active",
            value: "Active"
        },
        {
            text: "Former",
            value: "Former"
        }
    ];

    const handleStatusChange = (selectedValue) => {
        setUserSelectedStatus(selectedValue.value);
        setCollapse(false);
    };

    return (
        <MDBSideNavItem>
            <MDBSideNavLink icon='angle-down' shouldBeExpanded={collapse} onClick={() => setCollapse(!collapse)}>
                Status
            </MDBSideNavLink>
            <MDBSideNavCollapse open={collapse}>
                <div className="p-3">
                    <MDBSelect
                        data={statusOptions}
                        value={userSelectedStatus}
                        onChange={handleStatusChange}
                        label="Select Status"
                    />
                </div>
            </MDBSideNavCollapse>
        </MDBSideNavItem>
    );
};

export default Status;